import Api from "../../../util/Api";

export default function getInitState() {
    return {
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-share"></i>',
                title: 'Újraküldés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'resend',
                additionalButtonVisible: 'eesztResendButtonVisible'
            }
        ],
        searchFields: [
            {
                name: "applicationFunctionId",
                label: "EESZT funkció",
                formSize: 4,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getEesztFunctionTypes,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "status",
                label: "Státusz",
                formSize: 4,
                formType: 'select',
                selectOptions: {
                    externalOptionList: [{id: 'SUCCESS', text: 'Sikeres'}, {id: 'FAILED', text: 'Sikertelen'}],
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "createdOnFrom",
                label: "Időponttól",
                formSize: 4,
                formType: 'date'
            },
            {
                name: "createdOnTo",
                label: "Időpontig",
                formSize: 4,
                formType: 'date'
            },
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                sort: false,
                visibility: false,
            },
            {
                name: "applicationFunction.text",
                label: "EESZT funkció",
                sort: false,
                visibility: true,
            },
            {
                name: "status",
                label: "Státusz",
                sort: false,
                visibility: true,
                slot_name: "eeszt_status_format"
            },
            {
                name: "createdOn",
                label: "Keletkezés időpontja",
                sort: false,
                visibility: true,
                slot_name: "datetime_format"
            },
            {
                name: "modifiedOn",
                label: "Módosítás időpontja",
                sort: false,
                visibility: true,
                slot_name: "appointment_format"
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}
